import React, { useEffect, useState } from "react";
import {
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import useQueues from "../../hooks/useQueues";
import toastError from "../../errors/toastError";

const VERTICAIS = [
  "AUTO", "BEAUTY", "EDU", "ENTERTAIN", "FINANCE", "GOVT", "HOTEL", "GROCERY",
  "NONPROFIT", "EVENT_PLAN", "RESTAURANT", "HEALTH", "PROF_SERVICES", "RETAIL",
  "APPAREL", "TRAVEL", "OTHER",
];

const StepIdentificacao = ({ state, dispatch }) => {
  const [filas, setFilas] = useState([]);
  const { findAll: findAllQueues } = useQueues();

  useEffect(() => {
    (async () => {
      try {
        const listaFilas = await findAllQueues();
        setFilas(listaFilas);
      } catch (err) {
        toastError(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setCampo = (campo) => (e) =>
    dispatch({ type: "SET_CAMPO", campo, valor: e.target.value });

  return (
    <div>
      <Typography variant="h6" gutterBottom>
        {i18n.t("whatsappOficialWizard.identificacao.titulo")}
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        margin="dense"
        label={i18n.t("whatsappOficialWizard.identificacao.nome")}
        helperText={i18n.t("whatsappOficialWizard.identificacao.nomeAjuda")}
        value={state.nome}
        onChange={setCampo("nome")}
      />

      <FormControl variant="outlined" margin="dense" fullWidth>
        <InputLabel>{i18n.t("whatsappOficialWizard.identificacao.fila")}</InputLabel>
        <Select
          multiple
          value={state.queueIds}
          onChange={(e) =>
            dispatch({ type: "SET_CAMPO", campo: "queueIds", valor: e.target.value })
          }
          label={i18n.t("whatsappOficialWizard.identificacao.fila")}
          renderValue={(selecionadas) => (
            <div>
              {selecionadas.map((id) => {
                const fila = filas.find((f) => f.id === id);
                return fila ? (
                  <Chip key={id} size="small" label={fila.name} style={{ marginRight: 4 }} />
                ) : null;
              })}
            </div>
          )}
        >
          {filas.map((fila) => (
            <MenuItem key={fila.id} value={fila.id}>
              {fila.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl variant="outlined" margin="dense" fullWidth>
        <InputLabel>{i18n.t("whatsappOficialWizard.identificacao.vertical")}</InputLabel>
        <Select
          value={state.vertical}
          onChange={setCampo("vertical")}
          label={i18n.t("whatsappOficialWizard.identificacao.vertical")}
        >
          {VERTICAIS.map((v) => (
            <MenuItem key={v} value={v}>
              {i18n.t(`whatsappOficialWizard.verticais.${v}`)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography variant="caption" color="textSecondary">
        {i18n.t("whatsappOficialWizard.identificacao.verticalAjuda")}
      </Typography>
    </div>
  );
};

export default StepIdentificacao;
